import React from 'react'

import { flow, get, orderBy } from 'lodash'
import { handleActions } from 'redux-actions'
import { createSelector } from 'reselect'

import httpClient, { catchError } from '@emmacare/common/api/httpClient'

import { setCompanyEmployees } from 'src/store/modules/actionCreators'
import { companySelector } from 'src/store/modules/company/selectors'

import { COMPANY_EMPLOYEES } from 'src/constants'
import { addAllValue } from 'src/utils/DataTrees'
import { addAllValue as addAllValueV5 } from 'src/utils/v5/DataTrees'

/* --------- reducer --------- */
const initialState = []

export default handleActions(
  {
    [setCompanyEmployees](state, { payload = [] }) {
      return [...payload]
    }
  },
  initialState
)

/* --------- thunks --------- */
export const getCompanyEmployees =
  ({ query = {} }) =>
  async (dispatch) => {
    try {
      const { items = [] } = await httpClient.get({
        pathname: COMPANY_EMPLOYEES,
        query
      })

      dispatch(setCompanyEmployees(items))

      return items
    } catch (err) {
      catchError(err)
    }
  }

/* --------- selectors --------- */
export const companyEmployees$ = createSelector(companySelector, (company) =>
  get(company, 'employees', [])
)

export const companyEmployeesOrderByEnabledWithAll$ = createSelector(
  companyEmployees$,
  (employees = []) =>
    flow(
      (employees) =>
        employees.map((item) => ({
          ...item,
          enabled: +item.enabled,
          fullName: item.enabled ? (
            item.fullName
          ) : (
            <span
              style={{
                fontStyle: 'italic'
              }}>{`${item.fullName} (inactive)`}</span>
          ),
          searchField: item.enabled
            ? item.fullName
            : `${item.fullName} (inactive)`
        })),
      (employees) => orderBy(employees, ['enabled'], ['desc']),
      (employees) => addAllValue(employees, true, 'All Users')
    )(employees)
)

export const companyEmployeesOrderByEnabledWithAllV5$ = createSelector(
  companyEmployees$,
  (employees = []) =>
    flow(
      (employees) =>
        employees.map((item) => ({
          ...item,
          enabled: +item.enabled,
          fullName: item.enabled ? (
            item.fullName
          ) : (
            <span
              style={{
                fontStyle: 'italic'
              }}>{`${item.fullName} (inactive)`}</span>
          ),
          searchField: item.enabled
            ? item.fullName
            : `${item.fullName} (inactive)`
        })),
      (employees) => orderBy(employees, ['enabled'], ['desc']),
      (employees) =>
        addAllValueV5({
          list: employees,
          convertList: true,
          allItem: {
            key: 'all',
            title: 'All Users',
            label: 'All Users',
            value: '',
            children: []
          }
        })
    )(employees)
)
